"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationSummaryWidget = void 0;
var React = require("react");
var WidgetBase_1 = require("../WidgetBase");
var journey_model_1 = require("@athena-portal/journey-model");
var ValidationSummaryWidget = exports.ValidationSummaryWidget = /** @class */ (function (_super) {
    __extends(ValidationSummaryWidget, _super);
    function ValidationSummaryWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValidationSummaryWidget.prototype.render = function () {
        var messages = this.renderMessages();
        if (messages && messages.length > 0) {
            return (React.createElement("div", { className: "alert alert-danger journey-validation-summary" },
                React.createElement("ul", null, messages)));
        }
        else {
            return null;
        }
    };
    ValidationSummaryWidget.prototype.renderMessages = function () {
        var showQuestionValidationErrors = this.getSetting("showQuestionValidationErrors", true);
        var showPageValidationErrors = this.getSetting("showPageValidationErrors", true);
        var outputList = [];
        var index = 0;
        if (showQuestionValidationErrors && this.props.validations) {
            for (var _i = 0, _a = Object.keys(this.props.validations); _i < _a.length; _i++) {
                var questionName = _a[_i];
                var questionValidationResult = this.props.validations[questionName];
                if (questionValidationResult && questionValidationResult.errors) {
                    for (var _b = 0, _c = questionValidationResult.errors; _b < _c.length; _b++) {
                        var error = _c[_b];
                        index++;
                        outputList.push(React.createElement('li', { key: "validationSummary" + index }, error));
                    }
                }
            }
        }
        if (showPageValidationErrors && this.props.pageValidations) {
            for (var _d = 0, _e = this.props.pageValidations; _d < _e.length; _d++) {
                var validation = _e[_d];
                if (validation.errorMessage) {
                    index++;
                    outputList.push(React.createElement('li', { key: "validationSummary" + index }, validation.errorMessage));
                }
            }
        }
        return outputList;
    };
    ValidationSummaryWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "showQuestionValidationErrors", type: journey_model_1.TypeDescriptions.Boolean },
            { name: "showPageValidationErrors", type: journey_model_1.TypeDescriptions.Boolean },
        ]),
        (0, journey_model_1.questionConfiguration)({
            noChildren: true,
            noPlaceholder: true,
            noLabel: true,
            noInteractionField: true,
            noValidations: true
        })
    ], ValidationSummaryWidget);
    return ValidationSummaryWidget;
}(WidgetBase_1.WidgetBase));
//# sourceMappingURL=ValidationSummaryWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/widgets/output/ValidationSummaryWidget.js
// module id = 2381
// module chunks = 0